import React, { useState ,useEffect} from "react";
import logo from "../../../../../../src/assets/images/logo.png";
import { useParams, useLocation,useNavigate  } from "react-router-dom";
import axiosInstance from "../../../../../services/AxiosInstance";
import { showErrorAlert } from "../../../../../services/ErrorHandlingService";

const VirtualId = () => {
  const { patientId } = useParams();
  let decodedId = null;
  try {
    decodedId = patientId ? atob(patientId) : null;
  } catch (e) {
    console.error("Invalid Base64 patientId:", e);
    decodedId = patientId; 
  }

  const [patientDetails, setPatientDetails] = useState(null);

  useEffect(() => {
    const loadVirtualIdDetails = async () => {
      try {
        console.log("Fetching patient details from backend...");
  
        const response = await axiosInstance.post(
          "/admin/getVirtualIDDetails",
          { patient_id: decodedId }, // no admin_id here
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            transformRequest: [
              (data, headers) => {
                const cleaned = { ...data };
                delete cleaned.admin_id;
  
                const params = new URLSearchParams();
                for (const [key, value] of Object.entries(cleaned)) {
                  if (value !== undefined && value !== null)
                    params.append(key, value);
                }
                return params.toString();
              },
            ],
          }
        );
  
        console.log("Backend response:", response.data);
  
        if (response.data.status === "success" && response.data.data) {
          setPatientDetails(response.data.data);
        } else {
          throw new Error("Invalid response");
        }
      } catch (err) {
        console.error("Error loading form:", err);
        showErrorAlert("Failed to load patient details. Please try again.");
      }
    };
  
    if (decodedId) {
      loadVirtualIdDetails();
    }
  }, [decodedId]);
  
  useEffect(() => {
    if (patientDetails) {
      console.log("Updated patientDetails:", patientDetails);
    }
  }, [patientDetails]);
  
  const navigate = useNavigate();

  // ⚠️ This clears token — move it to a safe spot or disable temporarily
  useEffect(() => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails");
    } catch (e) {
      console.warn("Error clearing localStorage:", e);
    }
  }, []);

  return (
    <div className="authentication">
      <div className="container">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-7 col-lg-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="form-group text-center">
                      <img
                        src={logo}
                        alt="Logo"
                        style={{ width: "50%", height: "auto" }}
                      />
                    </div>
                    <h3 className="text-center mb-4">Virtual ID</h3>

                    {patientDetails ? (
                      <>
                        <div className="text-center">
                          <h4>
                            {patientDetails?.first_name +
                              " " +
                              patientDetails?.middile_name +
                              " " +
                              patientDetails.last_name}
                          </h4>
                        </div>
                        <div className="text-center">
                          <span>
                            <i className="fa fa-phone me-2"></i>
                            {patientDetails.whatsapp_contact_no}
                          </span>
                        </div>
                        <div className="text-center">
                          <span>
                            <i className="fa fa-envelope me-2"></i>
                            {patientDetails.patient_email}
                          </span>
                        </div>
                        <div className="text-center mt-5 mb-5">
                          <img
                            src={patientDetails.patient_qrcode}
                            alt="QR Code"
                            style={{ maxWidth: "200px", height: "auto" }}
                          />
                        </div>
                      </>
                    ) : (
                      <p>Data not available</p>
                    )}

                    <p className="text-center">
                      Scan the above QR code at the reception
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VirtualId;
